import * as Yup from 'yup';

const bookDemoFormSchema = () =>
  Yup.object().shape({
    firstName: Yup.string().trim().required('First name is required.'),
    lastName: Yup.string().trim().required('Last name is required.'),
    phone: Yup.string()
      .trim()
      .matches(/^\+?[0-9\s]+$/, 'Mobile number must contain only digits.')
      .min(8, 'Mobile number is too short.')
      .max(15, 'Mobile number is too long.')
      .required('Mobile number is required.'),
    email: Yup.string()
      .trim()
      .email(
        'Email is incorrect format. Please add the correct format of email.'
      )
      .required('Email is required.'),
  });

export default bookDemoFormSchema;
